module.exports = __webpack_public_path__ + "7f7d3bac3a7f6e111248e514e4cc92ff.svg";